export const statusVariants = {
  defaultPaymentMethod: {
    text: 'Default',
    iconName: 'check',
  },
  manufacturerCard: {
    text: 'Manufacturer card',
    iconName: 'localAtm',
  },
  expiredCard: {
    text: (expirationMonth: number, expirationYear: number) =>
      `Expired ${expirationMonth}/${expirationYear}`,
    iconName: 'warningNotificationIcon',
  },
  invalidPaymentMethod: {
    text: 'This payment method is no longer valid.',
    iconName: 'warningNotificationIcon',
  },
} as const;
